class VerticalSeedHero {
    constructor(el) {
        // DOM Elements
        this.el = el;
        this.canvas = this.el.querySelector('.eclipse-canvas');
        this.ctx = this.canvas.getContext("2d");

        // Event Handlers
        this.resizeHandler = this.handleResize.bind(this);
        this.animate = this.animate.bind(this);
        this.generatePoints = this.generatePoints.bind(this);

        this.resizeTimeout = null; // Timeout for handling resize event

        this.points = []; // Array for storing generated points
        this.tweens = []; // Array for storing tweens during wave animation

        this.mouseX = 0; // Mouse X position
        this.mouseY = 0; // Mouse Y position

        window.addEventListener('mousemove', (e) => {
            const rect = this.canvas.getBoundingClientRect();
            this.mouseX = event.clientX - rect.left;
            this.mouseY = event.clientY - rect.top;
        });

        // Event Listeners and Intervals
        this.isBlurred = false;
        window.addEventListener('blur', function() {
            this.isBlurred = true;
        });

        window.addEventListener('focus', function() {
            this.isBlurred = false;
        });

        window.addEventListener('resize', this.resizeHandler);
        window.addEventListener('click', () => {
            if (this.isWave) {
                this.wavesQueue ++;
                return;
            }

            this.startWaving();
        });

        this.handleBreakpoints();
        // Initial Function Calls
        this.handleResize();
        this.startWaving();
    }

    handleBreakpoints() {
        const tabletBreakpoint = 768; // Screen width for tablet (in pixels)
        const phoneBreakpoint = 480; // Screen width for phone (in pixels)

        // Animation Settings
        this.numPoints = 400; // Number of points in animation
        this.startRadius = 300; // Starting radius for point generation
        this.density = 1.2; // Point density in point generation
        this.spiralStep = 0.2; // Step size for the spiral during point generation
        this.rotationSpeedFactor = 0.1; // Rotation speed factor for point generation

        // Wave Settings
        this.waveSpeed = 1.3; // Speed of the wave animation
        this.maxScaleFactor = 2; // Maximum scaling factor for point during wave animation
        this.scaleUpTime = 400; // Time for scaling up in wave animation
        this.scaleDownTime = 400; // Time for scaling down in wave animation
        this.scaleStayTime = 1; // Time for staying in scale in wave animation
        this.tweeningTime = 8; // Time for tweening during wave animation
        this.offsetDistance = 1.0; // Maximum distance for shifting points during wave animation
        this.wavesQueue = 0; // Queue for wave animations
        this.waveCooldown = 0; // Cooldown for wave animations

        // Point Settings
        this.scatterIncrease = 0.002; // Increase factor for scatter during point generation
        this.pointRadiusRange = [2, 5]; // Range for point radius
        this.pointAlphaRange = [0.2, 0.5]; // Range for point alpha
        this.pointColorRange = [[255, 255], [255, 255], [255, 255]]; // Range for point color

        // Scatter Settings
        this.scatterFactor = 1.2; // Factor for scatter during point generation
        this.scatterRange = 30; // Range for scatter during point generation
        this.scatterRangeX = [-this.scatterRange, this.scatterRange]; // Range for scatter in X direction
        this.scatterRangeY = [-this.scatterRange, this.scatterRange]; // Range for scatter in Y direction

        // Connection Settings
        this.connectionAngleRange = [0, Math.PI / 20]; // Angle range for making connections
        this.numNearestPointsRange = [1, 2]; // Range for number of nearest points to connect
        this.avoidCenter = false; // Flag to check if center point should be avoided

        // Other Settings
        this.maxRadius = 2000; // Maximum radius for the point animation

        // Circle Settings
        this.circleColor = [255, 255, 255]; // Color of the circle
        this.circleDiameter = 650; // Diameter of the circle
        this.circleLineWidth = 0.5; // Line width of the circle
        this.circleLineAlpha = 0.2; // Alpha of the circle line

        // Mouse Interaction Settings
        this.mouseRadius = 150; // Radius around the mouse for interaction
        this.mouseForce = 1.5; // Strength of the mouse interaction

        //Center Point
        this.centerPointShift = {
            x: 200,
            y: -450
        }

        if (window.innerWidth <= phoneBreakpoint) {
            // Animation Settings
            this.numPoints = 100; // Number of points in animation
            this.startRadius = 120; // Starting radius for point generation
            this.density = 3.2; // Point density in point generation
            this.spiralStep = 0.2; // Step size for the spiral during point generation

            // Circle Settings
            this.circleDiameter = 250; // Diameter of the circle

            // Wave Settings
            this.waveSpeed = 0.35; // Speed of the wave animation

            //Center Point
            this.centerPointShift = {
                x: 0,
                y: 0
            };
        } else if (window.innerWidth <= tabletBreakpoint) {
            // Animation Settings
            this.numPoints = 300; // Number of points in animation
            this.startRadius = 200; // Starting radius for point generation
            this.density = 3.2; // Point density in point generation
            this.spiralStep = 0.2; // Step size for the spiral during point generation

            // Circle Settings
            this.circleDiameter = 450; // Diameter of the circle

        }
    }

    // Add a call to handleBreakpoints() in the handleResize() method
    handleResize() {
        clearInterval(this.waveInterval);
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
            this.canvas.width = this.canvas.offsetWidth;
            this.canvas.height = this.canvas.offsetHeight;

            this.handleBreakpoints(); // Call handleBreakpoints() after resizing

            this.centerPoint = {
                x: this.canvas.width / 2 + this.centerPointShift.x,
                y: this.canvas.height / 2 + this.centerPointShift.y
            };

            this.points = [];
            this.generatePoints();
            this.prepareAnimation();

            if (!this.isAnimating) {
                this.animate();
            }

            this.startWaving();
        }, 500);
    }

    startWaving() {
        this.createWave();
        clearInterval(this.waveInterval);
        this.waveInterval = setInterval(() => {
            this.createWave();
        }, 5000);
    }

    generatePoints() {
        const startX = this.centerPoint.x;
        const startY = this.centerPoint.y;
        let scatterFactor = this.scatterFactor;

        for (let angle = 0; this.points.length < this.numPoints; angle += this.spiralStep) {
            const radius = this.startRadius + angle * this.density;
            scatterFactor += this.scatterIncrease * radius / this.startRadius;

            const x = startX + scatterFactor * radius * Math.cos(angle) + (Math.random() * (this.scatterRangeX[1] - this.scatterRangeX[0]) + this.scatterRangeX[0]);
            const y = startY + scatterFactor * radius * Math.sin(angle) + (Math.random() * (this.scatterRangeY[1] - this.scatterRangeY[0]) + this.scatterRangeY[0]);

            const radiusRandom = Math.random() * (this.pointRadiusRange[1] - this.pointRadiusRange[0]) + this.pointRadiusRange[0];

            const colorRandom = `${Math.floor(Math.random() * (this.pointColorRange[0][1] - this.pointColorRange[0][0])) + this.pointColorRange[0][0]}, 
            ${Math.floor(Math.random() * (this.pointColorRange[1][1] - this.pointColorRange[1][0])) + this.pointColorRange[1][0]}, 
            ${Math.floor(Math.random() * (this.pointColorRange[2][1] - this.pointColorRange[2][0])) + this.pointColorRange[2][0]}`;

            const alphaRandom = Math.random() * (this.pointAlphaRange[1] - this.pointAlphaRange[0]) + this.pointAlphaRange[0];

            const point = new Point(x, y, radiusRandom, colorRandom, alphaRandom);

            this.points.push(point);
        }

        this.findNearestPoints();
    }

    findNearestPoints() {
        const centerX = this.centerPoint.x;
        const centerY = this.centerPoint.y;
        const minAngle = this.connectionAngleRange[0];
        const maxAngle = this.connectionAngleRange[1];

        const randomSortedPoints = this.points.slice().sort(() => Math.random() - 0.5);

        for (let i = 0; i < randomSortedPoints.length; i++) {
            const numConnections = Math.floor(Math.random() * (this.numNearestPointsRange[1] - this.numNearestPointsRange[0])) + this.numNearestPointsRange[0];

            let distances = randomSortedPoints
                .map((point, index) => {
                    if (index === i) return Infinity;

                    const angleToCenter = (Math.atan2(randomSortedPoints[i].y - centerY, randomSortedPoints[i].x - centerX) + 2 * Math.PI) % (2 * Math.PI);
                    const angleToPoint = (Math.atan2(point.y - centerY, point.x - centerX) + 2 * Math.PI) % (2 * Math.PI);

                    if (!this.avoidCenter || (angleToCenter - minAngle <= angleToPoint && angleToPoint <= angleToCenter + maxAngle)) {
                        return {
                            distance: Math.hypot(randomSortedPoints[i].x - point.x, randomSortedPoints[i].y - point.y),
                            point: point
                        };
                    } else {
                        return Infinity;
                    }
                })
                .filter(item => item !== Infinity);

            distances.sort(() => Math.random() - 0.5);

            randomSortedPoints[i].nearestPoints = distances
                .filter(item => !item.point.nearestPoints.includes(randomSortedPoints[i]))
                .slice(0, numConnections);
        }
    }

    cutCircle(context, x, y, radius) {
        context.beginPath();
        context.arc(x, y, radius, 0, Math.PI * 2, true);
        context.fill();
    }

    getSpeedFactor() {
        return this.wavesQueue ? this.wavesQueue * 0.5 : 1;
    }

    getAlphaMultiplier(alpha) {
        return this.wavesQueue * 0.05 + alpha <= 1 ? this.wavesQueue * 0.05 + alpha : 1;
    }

    prepareAnimation() {
        this.twoPi = Math.PI * 2; // Pre-calculate these values

        // Assuming the rotationSpeedFactor and centerPoint are not going to change frequently
        this.points.forEach(point => {
            const distanceToCenter = Math.hypot(point.x - this.centerPoint.x, point.y - this.centerPoint.y);
            point.rotationSpeed = this.rotationSpeedFactor / distanceToCenter; // Compute and store the rotation speed for each point
        });
    }
    animate() {
        this.isAnimating = true;

        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        for (let point of this.points) {
            // Update mouse interaction
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            if (!isMobile){
                point.updateMouseInteraction(this.mouseX, this.mouseY, this.mouseRadius, this.mouseForce);
            }

            // Update point position
            const diffX = point.x - this.centerPoint.x;
            const diffY = point.y - this.centerPoint.y;
            const cos = Math.cos(point.rotationSpeed * this.getSpeedFactor());
            const sin = Math.sin(point.rotationSpeed * this.getSpeedFactor());

            point.x = this.centerPoint.x + diffX * cos - diffY * sin + point.offsetX;
            point.y = this.centerPoint.y + diffX * sin + diffY * cos + point.offsetY;

            point.draw(this.ctx);
        }

        for (let point of this.points) {
            this.ctx.beginPath();
            for (let nearestPoint of point.nearestPoints) {
                if (nearestPoint.point) {
                    this.ctx.moveTo(point.x, point.y);
                    this.ctx.lineTo(nearestPoint.point.x, nearestPoint.point.y);
                    this.ctx.strokeStyle = `rgba(${point.color}, ${point.alpha / 4})`;
                    this.ctx.stroke();
                }
            }
        }

        this.halfCircleDiameter = this.circleDiameter / 2;
        this.ctx.save();
        this.ctx.globalCompositeOperation = 'destination-out';
        this.cutCircle(this.ctx, this.centerPoint.x, this.centerPoint.y, this.halfCircleDiameter);
        this.ctx.restore();

        this.ctx.beginPath();
        this.ctx.arc(this.centerPoint.x, this.centerPoint.y, this.halfCircleDiameter, 0, this.twoPi);
        this.ctx.lineWidth = this.circleLineWidth + this.wavesQueue * 0.05;
        this.ctx.strokeStyle = `rgba(${this.circleColor[0]}, ${this.circleColor[1]}, ${this.circleColor[2]}, ${this.getAlphaMultiplier(this.circleLineAlpha)})`;
        this.ctx.stroke();

        this.updateCircleTween();
        this.updateTweens();

        requestAnimationFrame(this.animate.bind(this));
    }

    createWave() {
        if (this.isBlurred) return;

        this.isWave = true;
        this.createCircleTween();

        let nearestDistance = Infinity;
        for (let i = 0; i < this.points.length; i++) {
            const point = this.points[i];
            const distance = Math.hypot(point.x - this.centerPoint.x, point.y - this.centerPoint.y);
            if (distance < nearestDistance) {
                nearestDistance = distance;
            }
        }

        for (let i = 0; i < this.points.length; i++) {
            const point = this.points[i];
            const distance = Math.hypot(point.x - this.centerPoint.x, point.y - this.centerPoint.y);
            const offsetAngle = Math.atan2(point.y - this.centerPoint.y, point.x - this.centerPoint.x);

            const offsetX = Math.cos(offsetAngle) * this.offsetDistance;
            const offsetY = Math.sin(offsetAngle) * this.offsetDistance;

            const delay = (distance - nearestDistance) / this.waveSpeed;

            setTimeout(() => {
                this.createTween(point, distance, offsetX, offsetY);
            }, delay);
        }
    }

    createTween(point, distance, offsetX, offsetY) {
        const existingTween = this.tweens.find(tween => tween.point === point);
        if (existingTween) {
            point.radius = existingTween.originalRadius;
            point.x -= existingTween.offsetX;
            point.y -= existingTween.offsetY;

            this.tweens = this.tweens.filter(tween => tween !== existingTween);
        }

        this.tweens.push({
            time: 0,
            increaseTime: this.scaleUpTime,
            stayTime: this.scaleStayTime,
            decreaseTime: this.scaleDownTime,
            currentStage: 'increase',
            originalRadius: point.radius,
            maxRadius: point.radius * this.maxScaleFactor,
            point: point,
            offsetX: offsetX,
            offsetY: offsetY
        });
    }

    updateTweens() {
        for (let i = 0; i < this.tweens.length; i++) {
            const tween = this.tweens[i];
            tween.time += this.tweeningTime;

            if (tween.currentStage === 'increase' && tween.time > tween.increaseTime) {
                tween.currentStage = 'stay';
                tween.time = 0;
            } else if (tween.currentStage === 'stay' && tween.time > tween.stayTime) {
                tween.currentStage = 'decrease';
                tween.time = 0;
                tween.startRadius = tween.point.radius;
            } else if (tween.currentStage === 'decrease' && tween.time > tween.decreaseTime) {
                tween.point.radius = tween.originalRadius;
                tween.point.x -= tween.offsetX;
                tween.point.y -= tween.offsetY;
                tween.currentStage = 'finished'; // Mark the tween as finished
            } else if (tween.currentStage === 'increase') {
                tween.point.radius = this.easeOutQuad(tween.time, tween.originalRadius, tween.maxRadius - tween.originalRadius, tween.increaseTime);
                tween.point.x += tween.offsetX * (tween.time / tween.increaseTime);
                tween.point.y += tween.offsetY * (tween.time / tween.increaseTime);
            } else if (tween.currentStage === 'decrease') {
                tween.point.radius = this.easeOutQuad(tween.time, tween.startRadius, tween.originalRadius - tween.startRadius, tween.decreaseTime);
                tween.point.x -= tween.offsetX * (tween.time / tween.decreaseTime);
                tween.point.y -= tween.offsetY * (tween.time / tween.decreaseTime);
            }
        }

        // Remove finished tweens
        this.tweens = this.tweens.filter(tween => tween.currentStage !== 'finished');
        this.isWave = this.tweens.length > 0;



        if (!this.isWave && this.wavesQueue > 0 && this.waveCooldown <= 0) {
            this.wavesQueue --;
            this.startWaving();
            this.waveCooldown = 10;
        }
        else if (this.waveCooldown > 0) {
                this.waveCooldown -= 1;
        }
    }

    createCircleTween() {
        const increaseTime = 300; // Scale up time in milliseconds
        const decreaseTime = 300; // Scale down time in milliseconds

        this.circleTween = {
            time: 0,
            increaseTime: increaseTime,
            decreaseTime: decreaseTime,
            currentStage: 'increase',
            originalDiameter: this.circleDiameter,
            originalLineWidth: this.circleLineWidth,
            minDiameter: this.circleDiameter * 0.97, // Scale to 90% of the original size
            minLineWidth: this.circleLineWidth * 0.97, // Scale to 90% of the original size
        };
    }

    updateCircleTween() {
        if (!this.circleTween) {
            return;
        }

        const tween = this.circleTween;
        tween.time += this.tweeningTime;

        if (tween.currentStage === 'increase' && tween.time > tween.increaseTime) {
            tween.currentStage = 'decrease';
            tween.time = 0;
        } else if (tween.currentStage === 'increase') {
            this.circleDiameter = this.easeOutQuad(tween.time, tween.originalDiameter, tween.minDiameter - tween.originalDiameter, tween.increaseTime);
            this.circleLineWidth = this.easeOutQuad(tween.time, tween.originalLineWidth, tween.minLineWidth - tween.originalLineWidth, tween.increaseTime);
        } else if (tween.currentStage === 'decrease' && tween.time > tween.decreaseTime) {
            this.circleDiameter = tween.originalDiameter;
            this.circleLineWidth = tween.originalLineWidth;
            this.circleTween = null; // Remove the tween when it's finished
        } else if (tween.currentStage === 'decrease') {
            this.circleDiameter = this.easeOutQuad(tween.time, tween.minDiameter, tween.originalDiameter - tween.minDiameter, tween.decreaseTime);
            this.circleLineWidth = this.easeOutQuad(tween.time, tween.minLineWidth, tween.originalLineWidth - tween.minLineWidth, tween.decreaseTime);
        }
    }


    easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    easeOutQuad(t, b, c, d) {
        t /= d;
        return -c * t*(t-2) + b;
    }

    destroy() {
        window.removeEventListener('resize', this.resizeHandler);
    }
}

class Point {
    constructor(x, y, radius, color, alpha) {
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.originalRadius = radius; // Save the original radius
        this.color = color;
        this.alpha = alpha;
        this.nearestPoints = [];
        this.offsetX = 0; // Mouse interaction offset
        this.offsetY = 0; // Mouse interaction offset
    }

    draw(ctx) {
        ctx.save();
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${this.color}, ${this.alpha})`;
        ctx.fill();
        ctx.restore();
    }

    updateMouseInteraction(mouseX, mouseY, mouseRadius, mouseForce) {
        const distanceToMouse = Math.hypot(this.x - mouseX, this.y - mouseY);
        if (distanceToMouse < mouseRadius) {
            // Calculate scale factor based on the mouse proximity
            const scaleFactor = 1 + mouseForce * ((mouseRadius - distanceToMouse) / mouseRadius);
            // Update the radius
            this.radius = this.originalRadius * scaleFactor;

            // Calculate offset due to the mouse proximity
            const offsetFactor = mouseForce * ((mouseRadius - distanceToMouse) / mouseRadius);
            const angleToMouse = Math.atan2(this.y - mouseY, this.x - mouseX);
            // this.offsetX = Math.cos(angleToMouse) * offsetFactor;
            // this.offsetY = Math.sin(angleToMouse) * offsetFactor;
        } else {
            // Restore the original radius and offset if the mouse is too far
            this.radius = this.originalRadius;
            // this.offsetX = 0;
            // this.offsetY = 0;
        }
    }

}

export default VerticalSeedHero;
